<template>
  <div>
    <h1>Аналитика</h1>
    <month @change="setPeriod"/>
    <row>
      <grid-item xs="12" xl="4" mb="15px">
        <general :period="period" v-if="period"/>
      </grid-item>
      <grid-item xs="12" xl="4" mb="15px">
        <history :period="period" v-if="period"/>
      </grid-item>
      <grid-item xs="12" xl="4">
        <clients/>
      </grid-item>
    </row>
  </div>
</template>

<script>
import GridItem from '@/components/grid/GridItem'
import Row from '@/components/grid/Row'
import { mapMutations } from "vuex"
import Month from "@/pages/Cabinet/Master/Analytics/components/Month"
import General from "@/pages/Cabinet/Master/Analytics/components/General"
import History from "@/pages/Cabinet/Master/Analytics/components/History"
import Clients from "@/pages/Cabinet/Master/Analytics/components/Clients"

export default {
  name: 'Analytics',
  components: {General, Clients, GridItem, Row, Month, History},
  methods: {
    ...mapMutations(['openModal']),
    setPeriod(start, end) {
      this.period = {start, end}
    }
  },
  data() {
    return {
      period: null
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  display: none;
}

@media screen and (max-width: 991px) {
  h1 {
    display: block;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
    margin-bottom: 15px;
    margin-top: -10px;
    padding-top: 0;
  }

  .whiteBg {
    margin: 0 -15px;
  }
}
</style>
